import surveyAPI from 'api/base';

import { GetPayment, GetReferralEligibility, PostPaymentInfo } from './types';

export const getPayment: GetPayment = (uuid, paymentId) => {
  return surveyAPI.get(`/payments/${uuid}?payment_id=${paymentId}`);
};

export const postPaymentInfo: PostPaymentInfo = (data) => {
  return surveyAPI.post(`surveys:payment_info/`, data);
};

export const getReferralEligibility: GetReferralEligibility = (seid, surveyId) => {
  return surveyAPI.get(`surveys:payment_info/?seid=${seid}&survey_id=${surveyId}`);
};
